import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { forgotPassword, confirmPassword, UserConstants } from "../actions/user";
import ForgotPasswordPage from "../components/ForgotPassword";

interface MapStateToProps {
  auth: AuthenticationState;
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => ({
  auth: state.authentication,
});

interface MapDispatchToProps {
  forgotPassword: (email: string) => (dispatch: Dispatch<AuthenticationAction>) => Promise<void>;
  confirmPassword: (email: string, code: string, newPassword: string) => (dispatch: Dispatch<AuthenticationAction>) => Promise<void>;
  clearError: () => void;
}

const mapDispatchToProps = (dispatch: Dispatch): MapDispatchToProps => ({
  ...bindActionCreators({ forgotPassword, confirmPassword }, dispatch),
  clearError: () => dispatch({ type: UserConstants.CLEAR_AUTH_ERROR }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
